const tokenFromLS = (token) =>
  token || localStorage.getItem('token') // @todo || navigate('/')

export default tokenFromLS
